import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {WSResponse} from "./portfolio/portfolio.datatypes";

@Injectable()
export class BlogService {

    private _blogUrl = 'ws/blog.php';

    constructor(private http: HttpClient) {
    }

    getBlogList() {
        let url = this._blogUrl + "?cmd=list";
        return this.http.get<WSResponse>(url)
    }

    getBlogItem(id: string) {
        let url = this._blogUrl + "?cmd=item&id=" + id;
        return this.http.get<WSResponse>(url)
    }
}



// WEBPACK FOOTER //
// ./src/app/blog.service.ts